import React from 'react';
import './index.scss';

class TimeRangeWrapper extends React.Component {
  handleOnclick = () => {
    const { onClickCloseButton } = this.props;
    onClickCloseButton();
  };

  render() {
    return (
      <div className="time-range-wrapper">
        {this.props.children}
        <a className="close-button" onClick={this.handleOnclick}>
          <i className="icon-cancel1 fs-10" />
        </a>
      </div>
    );
  }
}

TimeRangeWrapper.defaultProps = {
  onClickCloseButton: () => null,
};

export default TimeRangeWrapper;
